import * as util from '../../util';

const useIsAssumedIdentity = () => util.getIsAssumedIdentity();

export default useIsAssumedIdentity;
